/**
 * Styles responsive pour une meilleure adaptation du widget
 */
export const RESPONSIVE_STYLES = `
  /* Améliorations responsive pour le contenu de la modal */
  
  /* Tablettes */
  @media (max-width: 768px) {
    .ringado-messages-container {
      font-size: 14px;
    }
    
    .ringado-message-bubble {
      max-width: 75%;
    }
  }

  /* Mobiles moyens */
  @media (max-width: 640px) {
    .ringado-chat-header {
      padding: 12px 16px;
    }
    
    .ringado-messages-container {
      padding: 12px;
      font-size: 14px;
    }
    
    .ringado-message-bubble {
      max-width: 80%;
      padding: 8px 12px;
      font-size: 14px;
    }
    
    .ringado-input-area {
      padding: 12px;
    }
    
    .ringado-input-field {
      font-size: 16px; /* Évite le zoom sur iOS */
    }
  }

  /* Petits mobiles */
  @media (max-width: 480px) {
    .ringado-chat-header {
      padding: 10px 12px;
    }
    
    .ringado-messages-container {
      padding: 8px;
      font-size: 13px;
    }
    
    .ringado-message-bubble {
      max-width: 85%;
      padding: 6px 10px;
      font-size: 13px;
      line-height: 1.4;
    }
    
    .ringado-input-area {
      padding: 8px;
    }
    
    .ringado-input-field {
      font-size: 16px;
      padding: 10px 12px;
    }
    
    .ringado-send-button {
      padding: 10px;
      min-width: 40px;
    }
  }

  /* Très petits écrans */
  @media (max-width: 320px) {
    .ringado-chat-header {
      padding: 8px 10px;
    }
    
    .ringado-messages-container {
      padding: 6px;
      font-size: 12px;
    }
    
    .ringado-message-bubble {
      max-width: 90%;
      padding: 6px 8px;
      font-size: 12px;
      line-height: 1.3;
    }
    
    .ringado-input-area {
      padding: 6px;
    }
    
    .ringado-input-field {
      font-size: 16px;
      padding: 8px 10px;
    }
  }

  /* Optimisations pour le bouton de chat */
  @media (max-width: 480px) {
    .ringado-chat-button {
      width: 50px;
      height: 50px;
      bottom: 16px;
      right: 16px;
    }
    
    .ringado-widget.bottom-left .ringado-chat-button {
      left: 16px;
    }
  }

  /* Optimisations pour les écrans courts en hauteur */
  @media (max-height: 600px) {
    .ringado-chat-header {
      padding: 8px 12px;
    }
    
    .ringado-messages-container {
      padding: 8px;
    }
    
    .ringado-input-area {
      padding: 8px;
    }
    
    .ringado-message-bubble {
      padding: 6px 10px;
      margin-bottom: 4px;
    }
  }

  /* Optimisations pour les écrans très courts */
  @media (max-height: 500px) {
    .ringado-chat-header {
      padding: 6px 10px;
      min-height: 40px;
    }
    
    .ringado-messages-container {
      padding: 6px;
    }
    
    .ringado-input-area {
      padding: 6px;
    }
    
    .ringado-message-bubble {
      padding: 4px 8px;
      margin-bottom: 3px;
      font-size: 12px;
    }
    
    .ringado-input-field {
      padding: 8px 10px;
    }
  }

  /* Optimisations pour les écrans en mode paysage sur mobile */
  @media (max-width: 768px) and (orientation: landscape) and (max-height: 500px) {
    .ringado-chat-header {
      padding: 6px 10px;
      min-height: 36px;
    }
    
    .ringado-messages-container {
      padding: 6px;
    }
    
    .ringado-input-area {
      padding: 6px;
    }
    
    .ringado-message-bubble {
      padding: 4px 8px;
      margin-bottom: 2px;
      font-size: 11px;
      line-height: 1.3;
    }
  }

  /* Optimisations spécifiques pour iPhone en mode paysage */
  @media (max-width: 812px) and (orientation: landscape) and (max-height: 375px) {
    .ringado-chat-modal {
      height: min(calc(100vh - 10px), 250px) !important;
      bottom: 2px !important;
    }
    
    .ringado-chat-header {
      padding: 4px 8px;
      min-height: 32px;
    }
    
    .ringado-messages-container {
      padding: 4px;
    }
    
    .ringado-input-area {
      padding: 4px;
    }
  }
`;
